import {
  Actions,
  getInitialState,
  State,
} from '@porterin/booking-flow/src/order-review/view/types/OrderReviewState';
import {
  DEFAULT_ORDER_REVIEW_CONTENT,
  OrderReviewContentVM,
} from '@porterin/booking-flow/src/order-review/view-model/order-review-content/OrderReviewContentVM';
import React, { Dispatch } from 'react';

export type OrderReviewContextType = {
  state: State;
  dispatch: Dispatch<Actions>;
  content: OrderReviewContentVM;
};

const getDefaultValue = (): OrderReviewContextType => ({
  state: getInitialState(),
  dispatch: () => {},
  content: DEFAULT_ORDER_REVIEW_CONTENT,
});

export const context =
  React.createContext<OrderReviewContextType>(getDefaultValue());

export const useOrderReviewContext = () => React.useContext(context);
